import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Portal, Typography } from '@mui/material';
import { noop } from 'rxjs';

import { MOPLA_RIDES_TYPES_SELECTED_CARD } from '@mopla/constants';
import { TripTypeEnum } from '@mopla/data-models';
import { useTranslation } from '@mopla/i18';

import { BottomSlider } from '../../molecules/BottomSlider/BottomSlider';
import { CollapsibleCard } from '../../molecules/CollapsibleCard/CollapsibleCard';
import { Responsive } from '../../molecules/Responsive/Responsive';
import { TransportCircle } from '../../molecules/TravelTypeSymbols/TransportCircle';
import { SideOverlay } from '../SideOverlay/SideOverlay';

import { Root } from './styled';
import { useMoplaRideTypesControl } from './useMoplaRideTypesControl';

export const MoplaRideTypesDrawer: FC = () => {
	const { t } = useTranslation('common');
	const { isOpened, handleClose } = useMoplaRideTypesControl();
	const [searchParams] = useSearchParams();
	const selectedCard = searchParams.get(MOPLA_RIDES_TYPES_SELECTED_CARD);

	const cardsData = useMemo(() => {
		return [
			{
				type: TripTypeEnum.PRODT,
				title: t(`ride_types.${TripTypeEnum.PRODT}.title`),
				description: t(`ride_types.${TripTypeEnum.PRODT}.description`),
			},
			{
				type: TripTypeEnum.LBODTFLEX,
				title: t(`ride_types.${TripTypeEnum.LBODTFLEX}.title`),
				description: t(`ride_types.${TripTypeEnum.LBODTFLEX}.description`),
			},
			{
				type: TripTypeEnum.LBT,
				title: t(`ride_types.${TripTypeEnum.LBT}.title`),
				description: t(`ride_types.${TripTypeEnum.LBT}.description`),
			},
			{
				type: TripTypeEnum.LBODT,
				title: t(`ride_types.${TripTypeEnum.LBODT}.title`),
				description: t(`ride_types.${TripTypeEnum.LBODT}.description`),
			},
		];
	}, [t]);
	const cardsDataDisplay = (
		<Root>
			{cardsData.map((data, index) => (
				<CollapsibleCard
					key={index}
					icon={<TransportCircle transportType={data.type} />}
					title={data.title}
					initialOpen={selectedCard === data.type}
					content={
						<Typography variant="body2" color="primary.dark">
							{data.description}
						</Typography>
					}
				/>
			))}
		</Root>
	);

	return (
		<Portal key="moplaRideTypesDrawer">
			<Responsive mobile>
				<BottomSlider
					open={isOpened}
					onClose={handleClose}
					title={t('ride_types.title')}
					disablePortal
					zIndex={40}
				>
					{cardsDataDisplay}
				</BottomSlider>
			</Responsive>
			<Responsive aboveMobile>
				<SideOverlay
					title={t('ride_types.title')}
					open={isOpened}
					onOpen={noop}
					onClose={handleClose}
					disablePortal
					zIndex={1500}
				>
					{cardsDataDisplay}
				</SideOverlay>
			</Responsive>
		</Portal>
	);
};
